
import lang from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'

import Vue from 'vue';
import {
  CheckboxGroup,
  Pagination,
  Autocomplete,
  Table,
  TableColumn,
  Tag,
  Tabs,
  TabPane,
  Radio,
  RadioGroup,
  Progress,
  Dialog,
  Select,
  Option,
  Checkbox,
  Carousel,
  Input,
  Form,
  FormItem,
  Button,
  CarouselItem,
  DatePicker,
  Loading,
  MessageBox,
  Message,
  Popover,
  Notification
} from 'element-ui';
Vue.use(Popover)
Vue.use(Tabs)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(TabPane)
Vue.use(DatePicker)
Vue.use(CheckboxGroup)
Vue.use(Tag)
Vue.use(TableColumn)
Vue.use(Autocomplete)
Vue.use(Table)
Vue.use(Progress)
Vue.use(Dialog)
Vue.use(Pagination)
Vue.use(Option)
Vue.use(Select)
Vue.use(Checkbox)
Vue.use(Input)
Vue.use(Button);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Form)
Vue.use(FormItem)

locale.use(lang)

Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
Vue.prototype.$confirm=MessageBox.confirm



